<template>
    <exception-page type="404"></exception-page>
</template>

<script>
import ExceptionPage from './ExceptionPage';

export default {
    name: '404',
    components: {ExceptionPage}
}
</script>

<style scoped>

</style>
